export const environment = {
    port:4001,
    production: true,
    apiUrl: 'https://api.baragdoh.fr',
    socketUrl: 'https://api.baragdoh.fr'
}
